<template>
  <div>
    <div class="ex" style="padding-top:10px">
      <!-- <div class="exInfo" v-if="false">
        <div class="ex-left">
          <h2 class="ex-title">
            {{exOnInfo.name||'大厅'}}
            <span style="color:#1890ff;display:inline-block;">&nbsp;官方在线</span>
          </h2>
          <p>{{exOnInfo.address||'地点'}}</p>
          <p>{{exOnInfo.exTime}}</p>
        </div>
        <div class="ex-rigth">
          <p class="r-t">
            <span @click="addFollow" v-if="!isFollow">关注</span>
            <span @click="delFollow" v-if="isFollow" class="hasFollow">已关注</span>
            <span @click="share">分享</span>
          </p>
          <p class="r-b">
            <span>
              <i class="icon iconfont icon-huabanfuben"></i>
              {{wCount(exOnInfo.followCount)}}
            </span>
            <span>
              <i class="icon iconfont icon-zhiboguankanshu" style="margin-right:2px;"></i>
              {{wCount(exOnInfo.viewCount)}}
            </span>
          </p>
        </div>
      </div> -->
      <pageBanner :list="homeBanners"></pageBanner>
    </div>
    <!-- <div class="ex-txt" :class="{view_false:exhibitionConfig && !exhibitionConfig.feature.enabledDataStatistics}">
      <div class="ex-txt-l" v-if="exhibitionConfig && exhibitionConfig.feature.enabledDataStatistics">已有{{exOnInfo.userCount ? countThous(exOnInfo.userCount):''}}人访问</div>  
      <div class="ex-txt-r" v-if="exhibitionConfig && exhibitionConfig.feature.enabledSupplyDemand && supplyList.length">
        <div class="txt">
          <div class="brand">供需</div>
          <div class="supplt_list" v-if="supplyList.length">
            <van-swipe style="height: 100%;" vertical autoplay="3000" :show-indicators="false">
              <van-swipe-item v-for="(item,index) in supplyList" :key="index" @click="LinkToSupply(item.id)">
                <p>{{item.content}}</p>
              </van-swipe-item>
            </van-swipe>
          </div>
          <p style="margin-left: 0.34rem;" v-else>暂无数据</p>
        </div>
      </div>
    </div> -->
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import pageBanner from "./pageBanner";
import liveShare from "@/components/live-share/index";  //分享
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ex-card",
  data() {
    return {
      isFollow: false,
      exOnInfo: {}, //展会信息数据
      giveExOn: {}, //展会信息接口
      supplyList:[],
      querySupplyDemand:{},     //供需接口
      shareV:{
        content:'',
        poster:'',
      },
      isShareV:true,
      homeBanners:[], //展会首页banner
      banners:{},
    };
  },
  components: { pageBanner,liveShare },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exonId:"getExhibitionId",
      exhibitionInfo:'getExhibitionInfo',
      exhibitionConfig:'getExhibitionConfig',
    }),
    exhibitionId() {
      return this.$route.params.id||this.exonId;
    },
  },
  beforeDestroy(){
    // this.$apollo.queries.giveExOn.stop()
  },
  async created() {
    await this.$Myapollo.getUserInfo(this);
    this.addView();
    this.checkShareInfo();
  },
  methods: {
    ...mapActions({
      addExhibitionFollower:"follower/addExhibitionFollower",    //展会关注
      delExhibitionFollower:"follower/delExhibitionFollower",   //取消展会关注
      getShareConfig:'wxShare/getShareConfig', //分享
      addExhibitionView:"follower/addExhibitionView",
      LinkToSupply:'linkTo/LinkToSupply',
      getSettingShare:'wxShare/getSettingShare', //分享配置
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    async addView(){
      let urse={
        name:this.userInfo.name,
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl,
      }
      let opt={
        exhibitionId:this.exhibitionId,
        userId:this.userInfo.userId
      }
      //let res=await this.addExhibitionView(opt);
      // this.getExonInfo();
      this.initExInfo();
    },
    //设置分享信息
    checkShareInfo(){
      this.$store.commit('wxShare/setFromType',0);
      let userInfo = {
        name: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl
      };
      let body = {
        exhibitionId: this.exhibitionId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
        fromType: 0,
      }
      this.$store.commit('wxShare/setFromData',body);
    },
    //千分位加逗号
    countThous(n) {
      let num = n.toString();
      let decimals = "";
      // 判断是否有小数
      num.indexOf(".") > -1 ? (decimals = num.split(".")[1]) : decimals;
      let len = num.length;
      if (len <= 3) {
        return num;
      } else {
        let temp = "";
        let remainder = len % 3;
        decimals ? (temp = "." + decimals) : temp;
        if (remainder > 0) {
          // 不是3的整数倍
          return (
            num.slice(0, remainder) +
            "," +
            num.slice(remainder, len).match(/\d{3}/g).join(",") +
            temp
          );
        } else {
          // 是3的整数倍
          return num.slice(0, len).match(/\d{3}/g).join(",") + temp;
        }
      }
    },
    //展会banner
    getBanners(){
      const query = gql`
        query banners($exhibitionId:Guid!){
          banners(exhibitionId:$exhibitionId,position:"show.page.home"){
            content
            covers
            enabledCountdown
            url
            endAt
            showIndex
            createAt
          }
        }
      `;
      this.$apollo.addSmartQuery("banners", {
        query: query,
        variables: {
          exhibitionId:this.exhibitionId
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
          console.log('请求回来了banners',res)
          let data = JSON.parse(JSON.stringify(res.data.banners));
          // let data=res.data.giveExInfo;
          if (data&&data.length) {
            
            console.log(this.homeBanners,'homeBanners')
          }else{
            console.log(this.exOnInfo,'haha');
            let demo={
              content:'',
              url:'',
              covers:'',
              enabledCountdown:false,
            }
            this.homeBanners=[];
          }
          this.$emit('requestOk','bannersIsOk')    //banner获取完成
        },
        error(err) {},
      });
    },
    initExInfo(){
      let data = this.exhibitionInfo.exhibition;
      data.exTime =moment(data.startData).format("YYYY/MM/DD") +"~" +moment(data.endDate).format("MM/DD");
      this.isFollow=data.isFollow;
      this.exOnInfo = data;
      data.banners.forEach(e=> {
        e.day=1;
        if(e.enabledCountdown&&e.content.indexOf('【时间】')!=-1){
          let day=moment(moment(e.endAt)).diff(moment(moment().startOf('day')),'days');
          e.content=e.content.replace(/【时间】/,` ${day} `); 
          e.day=day;
        }
      });
      data.banners.sort((a,b)=>{
        if(a.showIndex==b.showIndex){
          return moment(a.createAt).valueOf() - moment(b.createAt).valueOf()
        }else{
          return b.showIndex-a.showIndex
        }
      })
      if(data.banners.length){
        this.homeBanners=data.banners;
      }else{
        console.log(data.banner,'haha');
        let demo={
          content:'',
          url:'',
          covers:data.banner,
          enabledCountdown:false,
        }
        this.homeBanners=[demo];
      }
      this.$Bus.$emit('bannerChange',this.homeBanners[0].covers);
      this.$emit('requestOk','bannersIsOk');   //供需获取完成
        this.$nextTick(()=>{
          this.getShareData();
          this.getSupply();
        })
      // this.$emit('requestOk','exInfoIsOk')    //展会信息获取完成  
    },
    getExonInfo() {
      const query = gql`
        query exhibition($id: Guid!, $userId: String!) {
          giveExOn: exhibition(id: $id) {
            address #举办地点
            startData #开始日期
            endDate #结束日期
            followCount #关注数量
            viewCount #浏览数量
            userCount #访问数量
            isFollow(userId: $userId) #是否关注
            remark #介绍
            remarkEn
            logo  #展会logo
            name #展会名称
            shortName #展会简称
            host{
              address
              createAt
              id
              isDeleted
              linkName
              logo
              name
              phone
              remark
              shortName
              updateAt
            }
            banner  #海报
            banners(position: "show.page.home") {
              covers #封面 多个用;隔开
              content #内容
              enabledCountdown #是否启用倒计时
              exhibitionId #展会Id
              url #链接
              endAt
              createAt
              showIndex
            }
          }
        }
      `;
      this.$apollo.addSmartQuery("giveExOn", {
        query: query,
        variables: {
          id: this.exhibitionId,
          userId: this.userInfo.userId,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
          // console.log('请求回来了data banner',res)
          let data = JSON.parse(JSON.stringify(res.data.giveExOn));
          // let data=res.data.giveExInfo;
          if (data) {
            this.$store.commit("setHostInfo",data.host);
            data.exTime =moment(data.startData).format("YYYY/MM/DD") +"~" +moment(data.endDate).format("MM/DD");
            this.isFollow=data.isFollow;
            this.exOnInfo = data;
            this.$store.commit("setExhibitionInfo",{exhibition:data});
            console.log(data.banners,'banners')
            data.banners.forEach(e=> {
              e.day=1;
              if(e.enabledCountdown&&e.content.indexOf('【时间】')!=-1){
                let day=moment(moment(e.endAt)).diff(moment(moment().startOf('day')),'days');
                e.content=e.content.replace(/【时间】/,` ${day} `); 
                e.day=day;
              }
            });
            data.banners.sort((a,b)=>{
              if(a.showIndex==b.showIndex){
                return moment(a.createAt).valueOf() - moment(b.createAt).valueOf()
              }else{
                return b.showIndex-a.showIndex
              }
            })
            if(data.banners.length){
              this.homeBanners=data.banners;
            }else{
              console.log(data.banner,'haha');
              let demo={
                content:'',
                url:'',
                covers:data.banner,
                enabledCountdown:false,
              }
              this.homeBanners=[demo];
            }
          this.$Bus.$emit('bannerChange',this.homeBanners[0].covers);
          this.$emit('requestOk','bannersIsOk')    //供需获取完成
            this.$nextTick(()=>{
              this.getShareData();
              this.getSupply();
            })
            // console.log("展会信息", this.exOnInfo);
          }
          this.$emit('requestOk','exInfoIsOk')    //展会信息获取完成  
        },
        error(err) {},
      });
    },
    getSupply() {
      const query = gql`
        query querySupplyDemand($query:QueryInput!){
          querySupplyDemand(query:$query){
            items{
              content
              id
            }
          }
        }
      `;
      let order=[
        {
        "N":"createAt",
        "v":0
        }
      ]
      let where={
        "EqualB":{
          "n":"exhibitionId",
          "v":this.exhibitionId
        },
        "EqualC":{
          "n":"auditState",
          "v":1
        },
      }
      let opt={
        page:1,
        size:3,
        order:JSON.stringify(order),
        where:JSON.stringify(where)
      }
      this.$apollo.addSmartQuery("querySupplyDemand", {
        query: query,
        variables: {
          query:opt
        },
        fetchPolicy: "network-only", //清理缓存
        result(res) {
          // console.log('请求回来了',res)
          let data = JSON.parse(JSON.stringify(res.data.querySupplyDemand));
          // let data=res.data.giveExInfo;
          console.log(data,'供需接口')
          if (data) {
            this.supplyList=data.items;
          }
          this.$emit('requestOk','supplyIsOk')    //供需获取完成
        },
        error(err) {},
      });
    },
    async addFollow() {
      let userInfo={
        name:this.userInfo.name,
        avatarUrl:this.userInfo.avatarUrl,
        nickName:this.userInfo.nickName
      }
      let opt={
        exhibitionId:this.exhibitionId,
        userId:this.userInfo.userId,
        userInfo:JSON.stringify(userInfo)
      }
      let res=await this.addExhibitionFollower(opt);
      if(res.result){
        this.$toast.success("关注成功");
        this.isFollow = true;
        this.exOnInfo.followCount+=1;
      }else{
        this.$toast.fail('关注失败')
      }
    },
    async delFollow() {
      let opt={
        exhibitionId:this.exhibitionId,
        userId:this.userInfo.userId,
      }
      let res = await this.delExhibitionFollower(opt);
      if(res.result){
        this.exOnInfo.followCount-=1;
        this.$toast.success("取消关注");
        this.isFollow = false;
      }else{
        this.$toast.fail('取消失败')
      }
    },
    // async getShareVal(){
    //   let res = await this.getShareConfig(this.exhibitionId);
    //   if(res&&res){
    //     this.shareV=JSON.parse(res);
    //   }
    //   this.isShareV=true;
    // },
    async getShareVal(){
      let res = await this.getSettingShare({id:this.exhibitionId,name:'share.exhibition.config'});
      if(res){
        this.shareV=JSON.parse(res);
      }
      this.isShareV=true;
    },
    //分享点击
    async share(){
      if(!this.isShareV){
        await this.getShareVal();
      }
      let opt={
        title:'给您推荐一个线上展会',
        bannerTitle:this.exOnInfo.name||this.exOnInfo.shortName||'线上展会',
        subhead:'主题线上展',
        banner:this.shareV.poster ? [this.shareV.poster] : [this.exOnInfo.banner],
        type:"home"
      }
      this.$nextTick(()=>{
        this.$refs['liveShare'].open(opt);
      })
      await true
    },
    //分享标题，内容，图片
    async getShareData(){
      await this.getShareVal();
      let shareData={
        title:this.shareV.content?this.shareV.content:'诚邀您参观 '+this.exOnInfo.name+' 线上展',
        desc:this.shareV.des ||  this.exOnInfo.remark,
        imgUrl:this.exOnInfo.logo
      }
      this.$nextTick(()=>{
        this.$refs.liveShare.shareTo(shareData);
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.ex {
  margin: 0 0.3rem;
  padding-bottom: 10px;
  background-color: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.exInfo {
  padding:0.25rem 0.2rem ;
  display: flex;
  justify-content: space-between;
  .ex-left {
    width: calc(100% - 2.2rem);
    .ex-title {
      font-size: 0.26rem;
      font-weight: 600;
      line-height: 1.5;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding-bottom: 3px;
      span{
        font-size: 0.26rem;
      }
    }
    p {
      font-size: 0.2rem;
      line-height: 1.5;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .ex-rigth {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width:2.2rem;
    .r-t {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      span {
        width: 1rem;
        height: 0.46rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        font-size: 0.22rem;
      }
      span:first-child {
        margin-right: 0.2rem;
        background-color: #0190fe;
        color: #fff;
      }
      span:last-child {
        background-color: #fff;
        border: solid 1px #e6e6e6;
        color: #333;
      }
      .hasFollow {
        background-color: #e6e6e6 !important;
      }
    }
    .r-b {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #999;
      font-size:0.22rem !important;
      span {
        display: flex;
        align-items: center;
        font-size: 0.22rem !important;
      }
      span:first-child {
        margin-right: 0.2rem;
      }
      
    }
  }
}
.ex-txt {
  display: flex;
  margin:0.3rem;
  align-items: center;
  &.view_false{
    .ex-txt-r{
      width: 100%;
    }
  }
  &-l {
    width: 50%;
    font-size: 0.24rem;
    color: #a72122;
    display: flex;
    align-items: center;
    font-weight: bold;
  }
  &-r {
    width: 50%;
    display: flex;
    align-items: center;
    background-color: #fff;
    font-size: 12px;
    color: #333;
    border-radius: 3px;
    background-color:#fff;
    background-image: url("../../../assets/img/new/supply_bg.png") ;
    background-repeat:no-repeat;
    background-size: contain;
    padding-left:0.14rem;
    .txt {
      display: flex;
      height: 0.48rem;
      border-radius: 3px;
      align-items: center;
      width: 100%;
      p{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .supplt_list{
        height: 100%;
        margin-left: 0.34rem;
        max-width: calc(100% - 0.88rem);
        .van-swipe-item{
          display: flex;
          align-items: center;
        }
      }
      .brand {
        flex-shrink: 0;
        // border: solid 1px #c71318;
        color: #fff;
      }
     
    }
  }
}
</style>